import { createStore } from 'vuex'

export default createStore({
  state: {
    loader:0,
    // BaseApiURL:"https://alulaemde.manialab.sa/api/",
    // BaseImageURL:"https://alulaemde.manialab.sa/storage/",
    BaseApiURL:"https://alulaemde.info/api/",
    BaseImageURL:"https://alulaemde.info/storage/",    
    en_passport_type_list:[{id:'Ordinary Passport',text:'Ordinary Passport'},{id:'Official Passport',text:'Official Passport'},{id:'Diplomatic Passport',text:'Diplomatic Passport'},{id:'Emergency Travel Document',text:'Emergency Travel Document'},],
    ar_passport_type_list:[{id:'Ordinary Passport',text:'جواز سفر عادي'},{id:'Official Passport',text:'جواز سفر رسمي'},{id:'Diplomatic Passport',text:'جواز سفر دبلوماسي'},{id:'Emergency Travel Document',text:'وثيقة سفر طارئة'},],
    en_identification_types_list:[{id:'id',text: 'ID'}, {id:'passport',text: 'Passport'}],
    ar_identification_types_list:[{id:'id', text: 'هوية'}, {id:'passport', text: 'جواز سفر'}],
    emailRegex: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
    allowedImages:['jpg', 'jpeg', 'png'],
    allowedFiles:['jpg', 'jpeg', 'png', 'pdf'],
    
    companyData:{},
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
